import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from 'zenith/auth';
import { RESPONSE } from 'zenith/context';

export function rootRoleGuard(): boolean | UrlTree {
  const authService = inject(AuthService);
  const platform = inject(PLATFORM_ID);
  const response = inject(RESPONSE, { optional: true });

  const user = authService.getCurrentUser();
  const hasAtLeastOneRole = user?.getRoles()?.length > 0;

  if (hasAtLeastOneRole) {
    return true;
  }

  if (isPlatformServer(platform)) {
    response.redirect('/unauthorized');

    return false;
  }

  return inject(Router).createUrlTree(['/unauthorized']);
}
